import React from "react";
import { FaEye, FaMobileAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const ProfileHeaderCard = ({ profile }) => {
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  return (
    <div className="relative flex flex-col md:flex-row items-center md:items-start bg-white shadow p-4 rounded mb-4">
      {/* Top Right Preview Button */}

      <Link
        to={`/profile/${profile.user.id}`}
        target="_black"
        className="absolute Profile-preview top-3 right-3 flex text-decoration-none items-center text-blue-600 border bg-green border-blue-600 px-3 py-1 rounded hover:bg-blue-50 text-sm"
      >
        <FaEye className="mr-1" /> Profile Preview
      </Link>

      {/* Left: Profile Image */}
      <div className="w-32 h-32 bg-gray-100 rounded overflow-hidden flex items-center justify-center">
        {profile.photo ? (
          <img
            src={profile.photo || require("../../../assets/default_image.webp")}
            alt="Profile"
            className="object-cover w-full h-full"
          />
        ) : (
          <span className="text-gray-500 text-xs text-center px-2"></span>
        )}
      </div>

      {/* Right: Info */}
      <div className="flex-1 md:ml-6 md:mt-0">
        <h2 className="text-xl font-bold">
          {profile.user.first_name || "Your Name"}
        </h2>
        <p className="text-sm text-gray-600">
          Profile created for {profile.profile_created_for || "My Self"}
        </p>
        <p className="">Age: {calculateAge(profile.dob)} Yrs</p>
        <p className="">
          Height: {profile.height_feet} Ft {profile.height_inches} inches
        </p>
        {/* <p className="">
          {profile.religion}, {profile.caste}
        </p> */}
        <p className="">
          {profile.work_location_city}, {profile.work_location_state},{" "}
          {profile.work_location_country}
        </p>
        <p className="">
          {profile.highest_education} - {profile.occupation} -{" "}
          {profile.employed_in}
        </p>

        {/* Mobile number */}
        <p className=" flex items-center text-green-700">
          <FaMobileAlt className="mr-1" />
          <span className="font-bold">{profile.phone}</span>
          <span className="ml-2">(✔ Verified)</span>
        </p>
      </div>
    </div>
  );
};

export default ProfileHeaderCard;
